import request from '../Request';

export default {
    getLogoUrl(facilityCode) {
        return request.get("/api/v1/facility/getLogoUrl?facilityCode=" + facilityCode,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    }
}